module.exports = __webpack_public_path__ + "img/mp.a4f3e2ab.svg";